import { Title } from "../../../../../../stories/Title/Title";
import { Button } from "../../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";

import { CustomModal } from "../../../../../../utils/UtilFunctions";

import { ViewModalStyles } from "../../../../../../styles/CustomModalStyles";
import { LicenseTypes, PageFor } from "../../../../../../utils/Enum.types";
import Supplier from "../../../masters/supplier/Index";
import ItemList from "../../../item/ItemsList";

import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import Close from "../../../../../../images/Close.svg";
import React, { useState } from "react";
import ItemAndSupplierForm from "./ItemForm";
import TableEdit from "./TableEdit";
import Navbar from "../../../../../common/layout/Navbar";

export interface AddSEwithoutPEProps {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
}

export const enum StockEntryTable {
  Warranty_Start_Date = "warranty_start_date",
  Warranty_End_Date = "warranty_end_date",
  AMC_Start_Date = "amc_start_date",
  AMC_End_Date = "amc_end_date",
  INC_Start_Date = "inc_start_date",
  INC_end_Date = "inc_end_date",
  Maintained_By = "maintained_by",
  SL_No = "id",
  Serial_No = "serial_no",
  Brand = "brand",
  Model = "model",
  Batch = "batch",
  Expiry = "expiry",
  Warranty = "warranty",
  AMC_Enabled = "amc_enabled",
  AMC = "amc",
  Geo_Location = "geo_location",
  Insurance = "insurance",
  Stock_Location = "stock_location",
  Company = "company",
  Subsidiary = "subsidiary",
  Site = "site",
  Junction = "junction",
}
const AddSEwithoutPE = ({ setModalFlag, pageType }: AddSEwithoutPEProps) => {
  const navigate = useNavigate();

  const [refNo, setRefNo] = useState("");

  const autoCompleteInpt = document.getElementsByClassName(
    "MuiAutocomplete-input"
  );

  const [items, setItems] = useState(false);
  const [supplier, setSupplier] = useState(false);
  const { Purchase } = useAssetTableJson();
  const [filterColumns, setFilterColumns] = useState(false);
  const [viewConfig, setViewConfig] = useState(false);
  const [columns, setColumns] = useState(Purchase.StockEntry.Add.SubHeader);

  const handleColumnToggle = (field: string) => {
    setColumns((prevColumns) =>
      prevColumns.map((col) => {
        if (
          field === StockEntryTable.Warranty &&
          (col.field === StockEntryTable.Warranty_Start_Date ||
            col.field === StockEntryTable.Warranty_End_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        } else if (
          field === StockEntryTable.Insurance &&
          (col.field === StockEntryTable.INC_Start_Date ||
            col.field === StockEntryTable.INC_end_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        } else if (
          field === StockEntryTable.AMC &&
          (col.field === StockEntryTable.AMC_Start_Date ||
            col.field === StockEntryTable.AMC_End_Date)
        ) {
          return { ...col, hideable: !col.hideable };
        }

        return col.field === field ? { ...col, hideable: !col.hideable } : col;
      })
    );
  };

  return (
    <>
      {pageType === PageFor.GENERAL && (
        <Navbar NavType={LicenseTypes.SUBSIDIARY} />
      )}
      {pageType === PageFor.MODAL ? (
        <div className="add-stock-entry__title">
          <Title>Stock Entry Without Purchase Entry</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
      ) : (
        <Title>Stock Entry Without Purchase Entry</Title>
      )}

      <div
        className={`add-stock-entry${
          pageType === PageFor.GENERAL ? "" : "__modal"
        }`}
      >
        <ItemAndSupplierForm />
        <TableEdit />
        {pageType === PageFor.GENERAL ? (
          <Button mode="back" onClick={() => navigate(-1)} />
        ) : (
          <Button mode="cancel" onClick={() => setModalFlag(false)} />
        )}
      </div>

      <CustomModal
        isOpen={items}
        onRequestClose={() => setItems(!items)}
        contentComponent={
          <ItemList
            setModalFlag={setItems}
            pageType={PageFor.MODAL}
            NavType={LicenseTypes.ASSET}
          />
        }
        style={ViewModalStyles}
      />
      <CustomModal
        isOpen={supplier}
        onRequestClose={() => setSupplier(!supplier)}
        contentComponent={
          <Supplier setModalFlag={setSupplier} pageType={PageFor.MODAL} />
        }
        style={ViewModalStyles}
      />
    </>
  );
};

export default AddSEwithoutPE;
